import { render, staticRenderFns } from "./WelfareRedEnvelope.vue?vue&type=template&id=830365e6&scoped=true&"
import script from "./WelfareRedEnvelope.vue?vue&type=script&lang=js&"
export * from "./WelfareRedEnvelope.vue?vue&type=script&lang=js&"
import style0 from "./WelfareRedEnvelope.vue?vue&type=style&index=0&id=830365e6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "830365e6",
  null
  
)

export default component.exports